// extracted by mini-css-extract-plugin
export default {"formField":"oqa-z","error":"pqa-z","disabled":"qqa-z","fieldError":"rqa-z","errorText":"sqa-z","button":"tqa-z","acknowledgment":"uqa-z"};